module.exports = __webpack_public_path__ + "img/kefu.859dbdc2.png";